'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var greedySplit = require('greedy-split');
var connectMessageChannel = require('message-channel/connect');
var BaseStorage = require('../base-storage');

var _require = require('../utils/constants'),
    CONNECTION_MAX_TIMEOUT = _require.CONNECTION_MAX_TIMEOUT,
    MESSAGE_MAX_TIMEOUT = _require.MESSAGE_MAX_TIMEOUT;

var FrameStorageStrategy = function (_BaseStorage) {
  _inherits(FrameStorageStrategy, _BaseStorage);

  function FrameStorageStrategy(target, origin, token) {
    _classCallCheck(this, FrameStorageStrategy);

    var _this = _possibleConstructorReturn(this, (FrameStorageStrategy.__proto__ || Object.getPrototypeOf(FrameStorageStrategy)).call(this));

    _this.target = target;
    _this.origin = origin;
    _this.token = token;
    _this.channel;
    return _this;
  }

  _createClass(FrameStorageStrategy, [{
    key: 'getChannel',
    value: function getChannel() {
      var _this2 = this;

      if (this.channel) {
        return Promise.resolve(this.channel);
      }

      return connectMessageChannel('data-capsule', { target: this.target, origin: this.origin, connectionMaxTimeout: CONNECTION_MAX_TIMEOUT, messageMaxTimeout: MESSAGE_MAX_TIMEOUT }).then(function (channel) {
        _this2.channel = channel;
        return channel;
      });
    }
  }, {
    key: 'sendCommand',
    value: function sendCommand(method, params) {
      var _this3 = this;

      var payload = { data: params };

      return this.getChannel().then(function (sendToChannel) {
        var message = [_this3.token, method, JSON.stringify(payload)].join('|');

        return sendToChannel(message).then(function (e) {
          var _greedySplit = greedySplit(e.data, '|', 2),
              _greedySplit2 = _slicedToArray(_greedySplit, 2),
              status = _greedySplit2[0],
              payload = _greedySplit2[1];

          if (status === 'reject') {
            throw payload;
          }

          return JSON.parse(payload).data;
        });
      });
    }
  }, {
    key: 'setItem',
    value: function setItem() {
      for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      return this.sendCommand('setItem', params);
    }
  }, {
    key: 'getItem',
    value: function getItem() {
      for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        params[_key2] = arguments[_key2];
      }

      return this.sendCommand('getItem', params);
    }
  }, {
    key: 'removeItem',
    value: function removeItem() {
      for (var _len3 = arguments.length, params = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        params[_key3] = arguments[_key3];
      }

      return this.sendCommand('removeItem', params);
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems() {
      for (var _len4 = arguments.length, params = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        params[_key4] = arguments[_key4];
      }

      return this.sendCommand('getAllItems', params);
    }
  }]);

  return FrameStorageStrategy;
}(BaseStorage);

module.exports = FrameStorageStrategy;